<template>
  <div style="max-width: 100%;" class="px-2">
    <div class="text-h4" v-if="userName.length > 0">Hi {{ userName }}</div>

    <div class="container mt-10 text-h6">
      Your feed URL is
      <a :href="feedURL" target="_blank">
        {{ feedURL }}
      </a>
      <span class="ml-2" v-show="feedItemCount > 0"
        >({{ feedItemCount }} items)</span
      >
      <v-icon
        class="ml-2"
        size="22px"
        v-clipboard:copy="feedURL"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        >content_copy
      </v-icon>
      <br />
    </div>

    <div class="text-h6" style="max-width: 100%;">
      Email article links to reading@ashishb.net, add this bookmarklet
      <a :href="bookmarklet">+ Mindful Reading</a> to your Bookmarks, or
      directly add them below
    </div>
    <div
      class="mx-auto mt-10"
      style="width: 50%; max-width: 500px; min-width: 300px;"
    >
      <v-text-field
        v-model="contentURL"
        label="Enter a link here..."
        outlined
        clearable
        @keydown.enter="addItem"
        v-validate="{ url: { require_protocol: false } }"
        data-vv-as="URL"
        name="content_url"
      ></v-text-field>
      <span class="red--text">{{ errors.first("content_url") }}</span>
      <v-btn
        class="ml-2"
        color="primary"
        depressed
        @click="addItem"
        v-show="contentURL.length > 0 && !errors.first('content_url')"
      >
        Add
      </v-btn>
    </div>

    <div
      class="mx-auto mt-3"
      style="display: inline-block; max-width: min(100%, 500px);"
    >
      <!-- https://github.com/RSSapp/vue-rss-feed -->
      <VueRssFeed
        :feedUrl="feedPreviewURL"
        :name="
          numRssFeedItemsToShow > 0
            ? 'Latest ' + numRssFeedItemsToShow + ' items'
            : ''
        "
        :limit="numRssFeedItemsToShow"
        :key="rssFeedLastUpdatedCounter"
        style="display: inline-block; max-width:100%;"
      />
    </div>

    <!-- TODO, eventually move this to its own file -->
    <template>
      <div class="text-center ma-2 mb-2">
        <v-snackbar v-model="showSnackbar" :timeout="2000">
          {{ snackbarText }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="primary"
              text
              v-bind="attrs"
              @click="showSnackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </template>
  </div>
</template>

<script>
import VueRssFeed from "vue-rss-feed";

export default {
  name: "App",
  components: {
    VueRssFeed
  },
  props: {
    // This wraps a UserInfo object {DisplayName, FeedURL, FeedItemCount}
    userinfowrapper: {
      type: Object,
      required: true
    }
  },
  computed: {
    userName: function() {
      // alert(`User info is ${JSON.stringify(this.userinfowrapper.UserInfo)}`);
      return this.userinfowrapper.UserInfo["DisplayName"];
    },
    feedURL: function() {
      return this.userinfowrapper.UserInfo["FeedURL"];
    },
    feedPreviewURL: function() {
      return (
        this.userinfowrapper.UserInfo["FeedURL"] +
        `?${numItemsParamName}=${this.numRssFeedItemsToShow}`
      );
    },
    feedItemCount: function() {
      return this.userinfowrapper.UserInfo["FeedItemCount"];
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const url = urlParams.get("url");
    if (url) {
      this.contentURL = url;
      const addItemFunc = this.addItem;
      const f = async function() {
        if (await addItemFunc()) {
          const newURL = window.location.href.split("?")[0];
          // https://developer.mozilla.org/en-US/docs/Web/API/History/pushState
          window.history.pushState(null, "", newURL);
        }
      };
      window.setTimeout(f, 1000);
    }
  },
  data() {
    return {
      bookmarklet:
        'javascript:(function(){function addItem2(url){const hostname="https://reading.ashishb.net";const addItemEndpoint=hostname+"?url="+encodeURI(url);window.open(addItemEndpoint,"_blank");}addItem2(window.location);})();',
      contentURL: "",

      showSnackbar: false,
      snackbarText: "",

      numRssFeedItemsToShow: 10,
      rssFeedLastUpdatedCounter: 0
    };
  },
  methods: {
    onCopy: function(e) {
      // console.log("You just copied: " + e.text);
      this.showMessage(`Copied ${e.text}`);
    },
    onError: function(e) {
      this.showMessage(`Failed to copy text: ${e}`);
    },
    addItem: async function() {
      if (this.contentURL.length === 0) {
        this.showMessage("Cannot added empty item to feed");
        return false;
      }
      if (this.errors.first("content_url")) {
        return false;
      }
      let response;
      try {
        response = await addFeedItem(this.contentURL);
      } catch (e) {
        this.showMessage(`Failed to add: ${e.toString()}`);
        return;
      }
      if (response.status === 200) {
        this.showMessage(`Added to feed: ${this.contentURL}`);
        this.contentURL = "";
        // This will force re-render the RSS feed component
        // https://michaelnthiessen.com/force-re-render/
        this.rssFeedLastUpdatedCounter++;
        return true;
      } else if (response.status === LinkAlreadyErrorStatusCode) {
        if (
          confirm(
            `Link already added to feed: ${this.contentURL}\nDo you want to remove it?`
          )
        ) {
          console.log(`Link removed from the feed: ${this.contentURL}`);
          return await removeFeedItemAndHandleResponse(this, this.contentURL);
        } else {
          console.log(`Link not removed from the feed: ${this.contentURL}`);
        }
        // this.showMessage(`Link already added to feed: ${this.contentURL}`);
      } else {
        this.showMessage(`Failed to add new link: ${await response.text()}`);
        return false;
      }
    },
    showMessage: function(msg) {
      this.snackbarText = msg;
      this.showSnackbar = true;
    }
  }
};

const addItemEndpoint = "/v1/additem";
const removeItemEndpoint = "/v1/removeitem";
const numItemsParamName = "items";
const LinkAlreadyErrorStatusCode = 452;

// Returns true if it succeeds, false otherwise
async function removeFeedItemAndHandleResponse(appObject, url) {
  let response;
  try {
    response = await removeFeedItem(url);
  } catch (e) {
    console.error(`Failed to remove item: ${e.toString()}`);
    return false;
  }
  if (response && response.status === 200) {
    appObject.showMessage(
      `Removed link from your feed: ${await response.text()}. ` +
        `Some client-side aggregators might have cached it in the meanwhile though.`
    );
    appObject.rssFeedLastUpdatedCounter++;
    return true;
  } else {
    appObject.showMessage(`Failed to remove item: ${await response.text()}`);
    return false;
  }
}

async function addFeedItem(url) {
  return await postData(addItemEndpoint, { url: url });
}

async function removeFeedItem(url) {
  return await postData(removeItemEndpoint, { url: url });
}

async function postData(url = "", data = {}) {
  // Default options are marked with *
  return await fetch(url, {
    method: "POST",
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json"
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  });
}
</script>

<style scoped>
a {
  color: #c5a93b;
}
</style>
